import React from "react";

import { Image } from "../../../common/Image";
import { IProduct } from "../../../models/catalogue.interfaces";

interface IProps {
    rootProduct: IProduct | null;
    variant: IProduct | null;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 41 LOC, purely presentational with simple image filtering and rendering logic. Trivial migration.
export class GiftMainImage extends React.Component<IProps, IState> {
    render() {
        if (!this.props.rootProduct) {
            return null;
        }
        let images: IProduct["images"] = [];
        if (this.props.variant) {
            images = images.concat(this.props.variant.images);
        }
        images = images.concat(this.props.rootProduct.images);
        if (images.length <= 0) {
            return null;
        }
        // TODO(i18n): "Product Tile" is a hardcoded role name that may need translation if displayed to users or if role names are localized
        const image = images.filter((img) => {
            return img.role === "Product Tile";
        })[0];
        const altText = this.props.variant
            ? this.props.variant.title
            : this.props.rootProduct.title;
        return (
            <Image
                className="gift-main-image"
                src={image.original}
                alt={altText}
            />
        );
    }
}
